import { Helmet } from "react-helmet-async"
import { MailParsingUsageView } from "../../../MailMessages"

export default function CreditConsumptionMailParsingPage() {
	return (
		<>
			<Helmet>
				<title>Mail Parsing Credits</title>
			</Helmet>
			<MailParsingUsageView />
		</>
	)
}
